import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DataTable, Anchor, Box, Heading } from 'wt-ui';
import { Link as LinkIcon } from 'grommet-icons';
import { Trans } from 'react-i18next';
import i18next from '../../translations/i18n';

import API from '../../services/API';

import heap from '../../containers/App/heap';

const ProductsTable = (props) => {
  const [loading, setLoading] = useState(true);
  const [longProducts, setLongProducts] = useState([]);
  const [shortProducts, setShortProducts] = useState([]);
  const { underlying, assetClass } = props;

  const loadProducts = async () => {
    const response = await API.getProductsFromUnderlying(underlying);
    // filter long products only - we have to use both names and leverage factor as fallback until leverage factor value are fixed across all products
    const lp = response.filter((x) => {
      if (assetClass === 'Currencies') {
        return true;
      }
      const lIndex = x.name.toLowerCase().indexOf('long');
      const sIndex = x.name.toLowerCase().indexOf('short');
      if (lIndex < 0 && sIndex < 0) {
        // boost long products do not include "long"
        return x.leverageFactor.indexOf('-') < 0;
      }
      return lIndex >= 0 && (sIndex < 0 || lIndex < sIndex);
    });
    // filter short products only
    const sp = response.filter((x) => {
      const lIndex = x.name.toLowerCase().indexOf('long');
      const sIndex = x.name.toLowerCase().indexOf('short');
      return sIndex >= 0 && (lIndex < 0 || sIndex < lIndex);
    });
    setLongProducts(lp);
    setShortProducts(sp);
    setLoading(false);
  };

  useEffect(() => {
    loadProducts();
  }, []);

  if (loading) {
    return <div>...</div>;
  }

  const columns = [
    {
      property: 'name',
      header: i18next.t('Name'),
      primary: true,
      render: (datum) => (
        <Anchor
          href={datum.href}
          target="_blank"
          onClick={() => {
            heap.track('ClickProducts', { name: datum.name });
          }}
        >
          {datum.name}
        </Anchor>
      ),
    },
    {
      property: 'baseCurrency',
      header: i18next.t('Base Currency'),
    },
    /* {
      property: 'leverageFactor',
      header: i18next.t('Leverage Factor'),
    }, */
    {
      property: 'href',
      header: '',
      render: (datum) => (
        <Anchor
          primary
          href={datum.href}
          target="_blank"
          onClick={() => {
            heap.track('ClickProducts', { name: datum.name });
          }}
        >
          <LinkIcon size="small" color="#2DCCD3" />
        </Anchor>
      ),
    },
  ];

  if (longProducts.length <= 0 && shortProducts.length <= 0) {
    return (
      <>
        <Heading level={4} textAlign="center">
          {i18next.t('ProdNotAvailable')}
        </Heading>
      </>
    );
  }

  // currencies should be displayed in single table
  if (assetClass === 'Currencies') {
    return (
      <>
        <Heading level={3} secondary style={{ marginTop: '0px' }}>
          {i18next.t('ProductRelatedTo')} {i18next.t(underlying)}
        </Heading>
        <Box background="transparent">
          <DataTable data={longProducts} columns={columns} fullwidth />
        </Box>
      </>
    );
  }

  return (
    <>
      {longProducts.length > 0 ? (
        <>
          <Heading level={3} secondary style={{ marginTop: '0px' }}>
            {i18next.t('LongProdDesc')} <Trans>{underlying}</Trans>
          </Heading>
          <Box background="transparent">
            <DataTable data={longProducts} columns={columns} fullwidth />
          </Box>
        </>
      ) : (
        ''
      )}
      {shortProducts.length > 0 ? (
        <>
          <Heading level={3} secondary style={{ marginTop: longProducts.length > 0 ? '20px' : '0px' }}>
            {i18next.t('ShortProdDesc')} <Trans>{underlying}</Trans>
          </Heading>
          <Box background="transparent">
            <DataTable data={shortProducts} columns={columns} fullwidth />
          </Box>
        </>
      ) : (
        ''
      )}
    </>
  );
};
ProductsTable.propTypes = {
  underlying: PropTypes.string.isRequired,
  assetClass: PropTypes.string.isRequired,
};

export default ProductsTable;
